import { usePut } from '../../HttpClient';
import { MemoCategoryModel } from '@app/models';
import { referenceDataBaseUrl } from '../BaseUrls';
import { useMutationWithErrorHandling } from '../../../hooks/UseMutationWithErrorHandling';

export function useUpdateMemoCategory() {
  const put = usePut(true, "tms");
  const updateMemoCategory = (id: string, request: MemoCategoryModel) =>
    put<{ id: string }>(`${referenceDataBaseUrl}/memo-categories/${id}`, request);

  return useMutationWithErrorHandling({
    mutationFn: async ({ id, request }: { id: string; request: MemoCategoryModel }) =>
      await updateMemoCategory(id, request),
  });
}
